module.exports = __webpack_public_path__ + "img/car_scrappage1.a791a09a.jpeg";